import Vue from 'vue';

const mainEventBus = new Vue();

export default mainEventBus;
